module.exports = "<div class=\"{{ style.version }}\"> v{{ copy.version }} <span>| {{ copy.time }}</span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/entry/views/version/version.html
// module id = 1059
// module chunks = 0